/**
 * automatically creates attributes on a DOM element for cypress and jest (with possibility to expand it to others)
 * the prefix is useful when creating children of another test element
 * @example idTest('name') => 'data-cy=name'
 * @example idTest('name', 'parent') => 'data-cy=parent_name'
 */
export default (name?: string, ...prefixes: Array<string | undefined>) => {
  if (!name) return undefined;
  const ret = [...prefixes, name].filter(Boolean).join('_').replace(/:/g, '_');
  return {
    'data-test': ret,
    'data-testid': ret,
  };
};
